import * as types from '../actionTypes/annualReturnClient'

let defaultState = {
  annualReturnClients: [],
  currentAnnualReturnClient: {}
}

const annualReturnClientReducer = (state = defaultState, action) => {
  if (action.type === types.GET_ANNUAL_RETURN_CLIENT) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.annualReturnClient) {
      action.annualReturnClient = {}
    }else {
      action.annualReturnClient = {
        ...action.annualReturnClient,
        // convert dates into date objects before putting into store so they can be treated properly without needing to convert later
        AnnualReturnClientStartDate: action.annualReturnClient.AnnualReturnClientStartDate ? new Date(action.annualReturnClient.AnnualReturnClientStartDate) : null,
        AnnualReturnClientEndDate: action.annualReturnClient.AnnualReturnClientEndDate ? new Date(action.annualReturnClient.AnnualReturnClientEndDate) : null
      }
    }
    return {
      ...state,
      currentAnnualReturnClient: action.annualReturnClient
    }
  }
  else if (action.type === types.GET_CLIENTS_FOR_ANNUAL_RETURN) {
    if (!action.annualReturnClients) {
    action.annualReturnClients = []
  }
  return {
    ...state,
    annualReturnClients: action.annualReturnClients
  }
  }
  else if (action.type === types.UPDATE_CLIENT_FOR_ANNUAL_RETURN) {
    return {
      ...state,
      annualReturnClients: state.annualReturnClients.map(annualReturnClient => {
        return annualReturnClient.AnnualReturnClientId === action.annualReturnClient.AnnualReturnClientId ?
          {
            ...action.annualReturnClient
          } :
          {
            ...annualReturnClient
          }
      })
    }
  }
  else if (action.type === types.ADD_CLIENT_TO_ANNUAL_RETURN) {
    // the annual return client would exist in the array already as a normal client so remove then add
    let annualReturnClients = state.annualReturnClients.filter(client => client.ClientId !== action.annualReturnClient.ClientId)
    return {
      ...state,
      annualReturnClients: annualReturnClients.concat({
        ...action.annualReturnClient
      })
    }
  }
  else if (action.type === types.CLEAR_ANNUAL_RETURN_CLIENT) {
    return {
      ...state,
      currentAnnualReturnClient: {}
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default annualReturnClientReducer



// WEBPACK FOOTER //
// ./src/reducers/annualReturnClient.js